app.controller('appealBatchesController', function ($rootScope, $scope, safeApply, appealsService, systemService) {
  let controllerReady = false
  $scope.currentAppealBatchShown = 0

  init()

  $scope.appealBatchAction = (action, index) => {
    let b = $scope.appealBatches[index]
    console.log('action, index :>> ', action, index);
    console.log('b :>> ', b);
    switch (action) {
      case 'file_protest':
        file_protest(b.id, b.method_of_protest, b)
        break
      case 'set_to_scheduled':
      case 'set_to_filed':
        update_appeal_batch_status(action, b, index)
        break
    }
  }

  $scope.filterBatches = (action) => {
    let status = []
    if (action == 'Scheduled' || action == 'Filed') status.push(action)
    loadAppealBatches('', '', status)
  }

  async function update_appeal_batch_status(action, b, index) {
    let status = ''
    if (action == 'set_to_scheduled') status = 'Scheduled'
    if (action == 'set_to_filed') status = 'Filed'
    let updateAppealBatchStatusResults = await appealsService.updateAppealBatchStatus({ status: status, appeal_batch_id: b.id })
    if (updateAppealBatchStatusResults.data.success) {
      $scope.appealBatches[index].status = status
      toastr.success("Appeal Batch Status Updated.", "Success!", { timeout: 5000 })
    } else {
      toastr.error("There was an error updating the Appeal Batch.", "Database Error!", { timeout: 15000 })
    }
    safeApply($scope)
  }

  async function file_protest(id, method, batch) {
    let propertiesToProtestResults = await appealsService.getPropertiesToProtest({ batch_id: id, method: method })
    // let propertiesToProtestResults = await appealsService.getPropertiesToProtest({ batch_id: id, method: 'CSV_1' })

    switch (method) {
      case 'Agent Portal':
        $scope.protestList = {
          title: `#${batch.id} for ${batch.cad_code} - ${$scope.countyList[batch.cad_code].name}`,
          list: '',
          listClipboard: ''
        }
        let prepend = "", append = "", separator = ""
        try {
          prepend = $scope.countyList[batch.cad_code].agent_portal_output_wrappers.prepend
          append = $scope.countyList[batch.cad_code].agent_portal_output_wrappers.append
          separator = $scope.countyList[batch.cad_code].agent_portal_output_wrappers.separator
        } catch (error) { console.log('error :>> ', error); }
        propertiesToProtestResults.data.data.map(item => {
          $scope.protestList.list += `<div>${prepend}${item.account}${append}${separator}</div>`
          $scope.protestList.listClipboard += `${prepend}${item.account}${append}${separator}\r\n`
        })
        var agentPortalProtestListModal = new bootstrap.Modal(document.getElementById('agentPortalProtestList'))
        agentPortalProtestListModal.show()
        // Setup Clipboard copy buffer
        var ModalEl = document.getElementById('agentPortalProtestList')
        ModalEl.addEventListener('shown.bs.modal', function (event) {
          new ClipboardJS('.clipboard-trigger', {
            container: document.getElementById('agentPortalProtestList')
          })
        })
        safeApply($scope)
        break
      case 'Certified Mail':
        printDIVByID(propertiesToProtestResults.data.data, batch)
        break
      case 'CSV_1':
        createCSVFile_1(propertiesToProtestResults.data.data, batch)
        break
    }
  }

  function createCSVFile_1(props, batch) {
    createCSV1(props, batch.id)
  }

  function createCSV1(items, batch_id) {
    var Head = [["Account Number", "Property Owner", "Site Address", "Agent Code", "HB 201(Y/N)", "Market Equity Both (M/E/B)"]]
    for (var item = 0; item < items.length; ++item) {
      Head.push([
        `${items[item].account}\t`,
        '"' + String(items[item].owner) + '"',
        '"' + String(items[item].address) + '"',
        '"' + String(items[item].agent_code) + '"',
        '"' + String(items[item].request_evidence) + '"',
        '"' + String(items[item].protest_type) + '"'
      ])
    }
    var csvRows = [];
    for (var cell = 0; cell < Head.length; ++cell) {
      csvRows.push(Head[cell].join(','));
    }
    var csvString = csvRows.join("\n")
    let csvFile = new Blob([csvString], { type: "text/csv" })
    let downloadLink = document.createElement("a")
    downloadLink.download = `Harris_County_Appeal_Batch_ID_${batch_id}.csv`
    downloadLink.href = window.URL.createObjectURL(csvFile)
    downloadLink.style.display = "none"
    document.body.appendChild(downloadLink)
    downloadLink.click()
  }

  function printDIVByID(props, batch) {
    console.log('props, batch :>> ', props, batch);
    console.log("*******************");
    let width = 800
    let height = (width * 1.294)
    let win = window.open('', '', `height=${height},width=${width}`)
    let county = $scope.countyList[batch.cad_code]
    let table_rows = ''

    let agent_code = county.agent_id || ""
    let cad = county.county || ""
    let cad_address = `${county.mailing_address.address}<br>${county.mailing_address.city_state_zip}`
    let year = batch.year

    props.map(p => {
      table_rows += `
        <tr>
          <td style="text-align: left">${p.account}</td>
          <td style="text-align: left">${p.owner_name}</td>
          <td style="text-align: left">${p.full_address}</td>
          <td style="text-align: left">Market Value & Uniform and Equal</td>
        </tr>`
    })

    let table = `
    <table class="props-table">
      <thead>
        <tr style="border-top: 1px solid lightgray; border-bottom: 1px solid lightgray;">
          <th style="text-align: left">PID</th>
          <th style="text-align: left">Owner Name</th>
          <th style="text-align: left">Situs Address</th>
          <th style="text-align: left">Protest Reason</th>
        </tr>
      </thead>
      <tbody>
        ${table_rows}
      </tbody>
    </table>
    `
    let styles = `
      <style>
        * { padding: 0; margin: 0; }
        @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        body                { font-family: 'Poppins', sans-serif; width: 100%; font-size: 10pt; }
        img                 { width: 250px }
        table               { width: 100%; }
        .prop-table-wrapper { margin-top: 29px; }
        .props-table        { font-size: 10pt; border-collapse: collapse; }
        .props-table th     { border-top: 1px solid lightgray; border-bottom: 1px solid lightgray; }
        .agent-code         { font-weight: 600; background: yellow; padding: 1px 5px; margin: 7px 0; width: max-content; }
        .address-wrapper    { margin-bottom: 25px; }
        .address-table      {  }
        .grc                { text-align: left; }
        .cad                { text-align: right; }
        .cad-name           { color: gray; font-size: 1.15rem; font-weight: 700; }
        .highlight          { font-weight: 600; background: yellow; padding: 1px 5px; }
        .message            { margin-bottom: 10px; }
      </style>`

    let html = `      
      <html>
        ${styles}
        <body>          
          <div class="address-wrapper">
            <table class="address-table">
              <tbody>
                <tr class="grc">
                  <td>
                    <img src="https://storage.googleapis.com/proptax_images/grc_logo.png">
                    <div class="agent-code">Agent Code: ${agent_code}</div>
                    support@propertytax.io | 972.529.2828<br>
                    7200 University Dr Ste 324<br>
                    McKinney, Texas 75071
                  </td>
                  <td class="cad">
                    <div class="cad-name">${cad} Central Appraisal District</div>
                    ${cad_address}
                    <div style="font-weight: 600;">${year} Appeal List<br></div>
                    Certified Mail on ${getFormattedDate()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="message">
            <div>${cad} Appraisal Review Board</div>
            <br>
            We wish to appeal the following properties on the basis of <span class="highlight">MARKET VALUE and EQUAL & UNIFORM</span>.
            <table style="margin-top: 20px; border-spacing: 1.5em 0;">
              <tbody>
                <tr>
                  <td style="height: 65px; vertical-align: baseline;">SIGNED</td>
                  <td style="vertical-align: bottom;">${getFormattedDate()}</td>
                </tr>
                <tr>
                  <td style="border-top: 1px solid black;">Jim Goodrich</td>
                  <td style="border-top: 1px solid black;">Date</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="prop-table-wrapper">
            ${table}
          </div>
        </body>
      </html>
    `
    win.document.write(html)
    win.document.close()
    win.print()
  }

  $scope.filterAppeals = (filter) => {
    console.log('********* controllerReady :>> ', controllerReady);
    if (controllerReady === false) return
    console.log('filter :>> ', filter);
  }

  $scope.toggleAllBatchCounties = () => {
    for (let [key, value] of Object.entries($scope.appeals_stats.breakdown)) {
      $scope.appeals_stats.breakdown[key].checked = !$scope.appeals_stats.breakdown[key].checked
    }
    $scope.calcTotalBatchCount()
  }

  $scope.calcTotalBatchCount = () => {
    $scope.appeals_stats.selected_properties = 0
    $scope.appeals_stats.selected_counties = 0
    setTimeout(() => {
      for (let [key, value] of Object.entries($scope.appeals_stats.breakdown)) {
        if ($scope.appeals_stats.breakdown[key].checked == true) {
          $scope.appeals_stats.selected_properties += $scope.appeals_stats.breakdown[key].count
          $scope.appeals_stats.selected_counties++
        }
      }
      safeApply($scope)
    }, 0)
  }

  $scope.createAppealBatches = async () => {
    let appealBatches = []
    for (let [key, value] of Object.entries($scope.appeals_stats.breakdown)) {
      if ($scope.appeals_stats.breakdown[key].checked == true) {
        let a = $scope.appeals_stats.breakdown[key]
        appealBatches.push({ name: a.name, cad_code: a.cad_code, appeal_method: a.appeal_method, year: $scope.appConfig.tax_year })
      }
    }
    let createAppealBatchesResults = await appealsService.createAppealBatches(appealBatches)
    console.log('createAppealBatchesResults :>> ', createAppealBatchesResults);
    await loadAppealBatches()
    await loadAppealsByFilter()
    safeApply($scope)
  }

  $scope.showAppealsInBatch = async (id) => {
    if ($scope.currentAppealBatchShown == id) {
      $scope.closeAppealBatchPropertiesTable()
      return
    }
    let loadAppealsByBatchIDResults = await appealsService.loadAppealsByBatchID({ batch_id: id })
    console.log('loadAppealsByBatchIDResults :>> ', loadAppealsByBatchIDResults)
    $scope.appealBatchAppeals = loadAppealsByBatchIDResults.data.data
    $scope.currentAppealBatchShown = id
    safeApply($scope)
  }

  $scope.closeAppealBatchPropertiesTable = () => {
    $scope.currentAppealBatchShown = 0
    $scope.appealBatchAppeals = []
  }

  async function loadAppealsByFilter(filter = 'unassigned-appels') {
    let getAppealsByFilterOBJ = { filter: filter, countyList: $scope.countyList, year: 2026 }
    let getAppealsByFilterResults = await appealsService.getAppealsByFilter(getAppealsByFilterOBJ)
    if (getAppealsByFilterResults.data.success) {
      $scope.appeals = getAppealsByFilterResults.data.data
      $scope.appeals_stats = getAppealsByFilterResults.data.stats
    } else {
      $scope.appeals = []
    }
    safeApply($scope)
    console.log('**** $scope.appeals_stats :>> ', $scope.appeals_stats);
    console.log('$scope.appeals :>> ', $scope.appeals);
  }

  async function loadAppealBatches(county = '', year = '2026', status = []) {
    // Get Appeal Batches
    let getAppealBatchesOBJ = { county: county, year: '2026', status: status }
    console.log('getAppealBatchesOBJ :>> ', getAppealBatchesOBJ);
    console.log('getAppealBatchesOBJ :>> ', getAppealBatchesOBJ);
    let getAppealBatchesResults = await appealsService.getAppealBatches(getAppealBatchesOBJ)
    if (getAppealBatchesResults.data.success) {
      $scope.appealBatches = getAppealBatchesResults.data.data
    } else {
      $scope.appealBatches = []
    }
    console.log('$scope.appealBatches :>> ', $scope.appealBatches);
    safeApply($scope)
  }

  async function init() {
    // Get App Config - tax_year, agent_record
    let appConfigObj = { type: "getAppConfiguration", active_only: false }
    let appConfigResults = await systemService.functionCall(appConfigObj)
    if (appConfigResults.data.success) {
      $scope.appConfig = appConfigResults.data.data
    } else {
      $scope.appConfig = null
    }
    console.log('$scope.appConfig :>> ', $scope.appConfig);

    // Get County List
    let countyListResults = await systemService.functionCall({ type: "countyList", active_only: false })
    if (countyListResults.data.success) {
      let c = countyListResults.data.data,
        cl = {}
      c.map(item => {
        cl[item.cad_code] = item
      })
      $scope.countyList = cl
    } else {
      console.log("*** System Error ***")
    }

    await loadAppealBatches()
    await loadAppealsByFilter()

    controllerReady = true

    $(".mouseWheelStopPropagation").on("mousewheel", function (e) {
      let scrollRate = 1
      let $t = $(this)
      let dy = e.originalEvent.deltaY * scrollRate
      $t.scrollTop($t.scrollTop() + dy)
      // e.preventDefault()
      return false
    })
    $scope.countySelectAll = true
  }

  function getFormattedDate(date = new Date()) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return month + '/' + day + '/' + year;
  }

})